import { HomePage, InfoPage, AssistitiPage, EmergenzePage, OperatoriPage, 
    PuntiDiRaccoltaPage, ImpostazioniPage, EntiPage, InvitoPage, creazioneFiltriPage, 
    AnagraficaPersonalePage,
    FiltriPage,
    EmergenzaOperatorePage} from './pages';
import { withNavigationWatcher } from './contexts/navigation';

const routes = [
    {
        path: '/home',
        element: HomePage,
        requiredRoles: ['Proprietario', 'Operatore', 'Assistito']
    },
    {
        path: '/info',
        element: InfoPage,
        requiredRoles: ['Proprietario', 'Operatore', 'Assistito']
    },
    {
        path: '/anagraficaPersonale',
        element: AnagraficaPersonalePage,
        requiredRoles: ['Assistito']
    },
    {
        path: '/emergenze',
        element: EmergenzePage,
        requiredRoles: ['Proprietario', 'Operatore']
    },
    {
        path: '/assistiti',
        element: AssistitiPage,
        requiredRoles: ['Proprietario']
    },
    {
        path: '/enti',
        element: EntiPage,
        requiredRoles: ['Proprietario']
    },
    {
        path: '/operatori',
        element: OperatoriPage,
        requiredRoles: ['Proprietario']
    },
    {
        path: '/puntiDiRaccolta',
        element: PuntiDiRaccoltaPage,
        requiredRoles: ['Proprietario']
    },
    {
        path: '/impostazioni',
        element: ImpostazioniPage,
        requiredRoles: ['Proprietario']
    },
    {
        path: '/creazioneFiltri',
        element: creazioneFiltriPage,
        requiredRoles: ['Proprietario']
    },
    {
        path: '/Filtri',
        element: FiltriPage,
        requiredRoles: ['Proprietario', 'Collaboratore']
    },
    {
        path: '/EmergenzaOperatore',
        element: EmergenzaOperatorePage,
        requiredRoles: ['Operatore']
    },
    // {
    //     path: '/invite',
    //     element: InvitoPage
    // },

];

export default routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});
